export default "__VITE_ASSET__ca64b35d__"